import { z } from 'zod';
import { MAX_CODE_SIZE_BYTES } from '../../postcall-workflow-activities/action-types/code-code-1';
import { requiredString } from '../helpers';
const navigateStepValidator = z.object({
    action: z.literal('navigate'),
    url: requiredString('URL is required')
});
const actStepValidator = z.object({
    action: z.literal('act'),
    instruction: requiredString('Instruction is required'),
    xpath: z.string().optional(),
    try: z.boolean().optional()
});
const extractStepValidator = z.object({
    action: z.literal('extract'),
    instruction: requiredString('Instruction is required'),
    extractionSchema: z.record(z.string(), z.string().optional()).optional()
});
const variableConfigValidator = z.object({
    name: requiredString('Variable name is required'),
    value: requiredString('Variable value is required'),
    description: z.string().default(''),
    xpath: z.string().optional()
});
export const fillStepValidator = z.object({
    action: z.literal('fill'),
    instruction: requiredString('Instruction is required'),
    variables: z.array(variableConfigValidator).min(1, 'At least one variable is required'),
    try: z.boolean().optional()
});
const waitForNewTabStepValidator = z.object({
    action: z.literal('waitForNewTab')
});
const switchToTabStepValidator = z.object({
    action: z.literal('switchToTab'),
    tabNumber: z.number().int().min(1, 'Tab number must be 1 or greater')
});
const waitForLoadStepValidator = z.object({
    action: z.literal('waitForLoad')
});
const delayStepValidator = z.object({
    action: z.literal('delay'),
    ms: z.number().int().min(1).max(60_000)
});
const uploadFileFromBrowserbaseStepValidator = z.object({
    action: z.literal('uploadFileFromBrowserbase'),
    cssSelector: z.string().optional()
});
const saveDownloadStepValidator = z.object({
    action: z.literal('saveDownload'),
    fileName: z.string().optional()
});
const uploadAttachmentStepValidator = z.object({
    action: z.literal('uploadAttachment'),
    fileName: requiredString('File name is required'),
    cssSelector: z.string().optional()
});
const playwrightScriptStepValidator = z.object({
    action: z.literal('playwrightScript'),
    scriptId: requiredString('Script ID is required'),
    variables: z.record(z.string(), z.string()).optional()
});
const playwrightStepValidator = z.object({
    action: z.literal('playwright'),
    source: requiredString('Code is required').refine((source) => new TextEncoder().encode(source).length <= MAX_CODE_SIZE_BYTES, `Code must be under ${MAX_CODE_SIZE_BYTES / 1024}KB`)
});
export const clickStepValidator = z.object({
    action: z.literal('click'),
    instruction: requiredString('Instruction is required'),
    doubleClick: z.boolean().optional()
});
export const selectOptionFromDropdownStepValidator = z.object({
    action: z.literal('selectOptionFromDropdown'),
    instruction: requiredString('Instruction is required'),
    value: requiredString('Value is required')
});
export const keydownStepValidator = z.object({
    action: z.literal('keydown'),
    instruction: requiredString('Instruction is required'),
    key: requiredString('Key is required')
});
const backStepValidator = z.object({
    action: z.literal('back')
});
const forwardStepValidator = z.object({
    action: z.literal('forward')
});
const reloadStepValidator = z.object({
    action: z.literal('reload')
});
const openTabStepValidator = z.object({
    action: z.literal('openTab'),
    url: z.string().optional()
});
const closeTabStepValidator = z.object({
    action: z.literal('closeTab'),
    tabNumber: z.number().int().min(1, 'Tab number must be 1 or greater')
});
const BROWSER_USE_STEP_VALIDATORS = [
    navigateStepValidator,
    actStepValidator,
    extractStepValidator,
    fillStepValidator,
    waitForNewTabStepValidator,
    switchToTabStepValidator,
    waitForLoadStepValidator,
    delayStepValidator,
    uploadFileFromBrowserbaseStepValidator,
    saveDownloadStepValidator,
    uploadAttachmentStepValidator,
    playwrightScriptStepValidator,
    playwrightStepValidator,
    clickStepValidator,
    selectOptionFromDropdownStepValidator,
    keydownStepValidator,
    backStepValidator,
    forwardStepValidator,
    reloadStepValidator,
    openTabStepValidator,
    closeTabStepValidator
];
const BrowserUseStepValidator = z.discriminatedUnion('action', BROWSER_USE_STEP_VALIDATORS);
export const Browser_Use_Browser_Use_1_ConfigValidator = z.object({
    steps: z.array(BrowserUseStepValidator).min(1, 'At least one step is required')
});
//# sourceMappingURL=browser-use-browser-use-1.js.map